import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../../css/Products/AddHashtag.css";
import { hashtagsRequest } from "./HashtagsRequest";

function AddHashtag({
  theme = {},
  setAddHashtagStatus,
  selectedHashtags,
  setSelectedHashtags,
}) {
  const [active, setActive] = useState(false);

  const { t } = useTranslation();

  const [searchInputValue, setSearchInputValue] = useState("");

  const [data, setData] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 0);

    hashtagsRequest(setData);
  }, []);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setAddHashtagStatus(false);
          }, 150);
        }}
      ></div>
      <div
        className={`popupMainDiv noGap noPadding ${theme} ${active && "active"}`}
      >
        <div className={`headerDiv ${theme}`}>{t("add Hashtag")}</div>

        <div className="contentDiv noScroll">
          <div className={`hashtagsSearchDiv ${theme}`}>
            <input
              className="searchInput noPadding"
              placeholder={t("Search")}
              onChange={(e) => {
                setSearchInputValue(e.target.value);
              }}
            ></input>

            {searchInputValue.length > 0 && (
              <button
                className="addHashtagButton"
                onClick={() => {
                  if (searchInputValue.length > 0) {
                    setSelectedHashtags((prev) => [searchInputValue, ...prev]);
                  }
                }}
              >
                {t("Add")}
              </button>
            )}
          </div>

          {selectedHashtags.length > 0 && (
            <div className="selectedHashtagsDiv">
              {selectedHashtags.map((item, index) => {
                return (
                  <div
                    className={`selectedHashtagDiv ${theme}`}
                    key={index}
                    onClick={() => {
                      setSelectedHashtags((prev) =>
                        prev.filter((_, i) => i !== index),
                      );
                    }}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          )}

          <div className="registeredHashtagsDiv">
            {data.map((hashtag, index) => {
              return (
                <div
                  key={index}
                  className="registeredHashtagDiv"
                  onClick={() => {
                    setSelectedHashtags((prev) => [hashtag.name, ...prev]);
                  }}
                >
                  <div>{hashtag.name}</div>
                  <div>{hashtag.product_quantity}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddHashtag;
